export default {
  freightSourceShipownerTitle: 'Shipowner',
  freightSourcePeerTitle: 'Peer',
  freightSourceAgentPriceTitle: 'Agent Contract Rate',
  exportUserTitle: 'Exporter',
  exportStatusTitle: 'Export Status',
  exportFreightTitle: 'Export Freight Rates',
  exportScopeLockedTitle: 'Export Scope Locked',
  exportScopeLockedDesc: 'All published freight rates within your permission scope will be exported. Unpublished, expired, and deleted data will be excluded.',
  selectExportTemplateTitle: 'Select Export Template',
  confirmExportButton: 'Confirm Export',
  exportTemplateRouteCategoryName: 'Route Category Template',
  exportTemplateRouteCategoryDesc: 'One row per route, displaying container prices and surcharges horizontally.',
  exportTemplateCargoWiseName: 'CargoWise Template',
  exportTemplateCargoWiseDesc: 'Same fields as the route category template, exported in CargoWise Excel format.',
  exportSuccessDownloadRecordPrompt: 'Operation successful. Please check the download records.',
  dataUpdatingPrompt: 'Data is being updated, please wait'
}
